// extracted by mini-css-extract-plugin
var _1 = "KRSVjXcEUQ8T_jjTInWt";
var _2 = "bn_sX1CFFM8FUIXwaH0L";
var _3 = "wH8rbAHjfMIQn6J7mMnZ";
var _4 = "wH8rbAHjfMIQn6J7mMnZ";
var _5 = "mHyHlHQySgmAcMq_12T6";
var _6 = "v_flNxwxynE9PVPbxjey";
var _7 = "v_flNxwxynE9PVPbxjey";
var _8 = "Xn610m1LENgg40vrDK4T";
var _9 = "f50oWeq8vwQBdYsGu1fA";
var _a = "TPK3vgoko8cMDcBv5oXt";
var _b = "TPK3vgoko8cMDcBv5oXt";
var _c = "VofqrKNAQhcpVwxeyBMW";
var _d = "pD_7eV3L8GAWWd2MOTrr";
var _e = "A7iwkVHrEQUHz1Q3QhHg";
var _f = "A7iwkVHrEQUHz1Q3QhHg";
export { _1 as "cardNotification", _2 as "container", _3 as "container-sidenav", _4 as "containerSidenav", _5 as "flex", _6 as "general-dashboard", _7 as "generalDashboard", _8 as "menuIconPlaceholder", _9 as "navbar", _a as "no-print", _b as "noPrint", _c as "notificationIndicator", _d as "notificationsList", _e as "take-chat", _f as "takeChat" }
